module.exports = __webpack_public_path__ + "img/Frame 1056five.b791760c.png";